// src/locales/en/shops.js
export const shops = {
    
    createNewShop: "නව වෙළඳසැලක් සාදන්න",
    setupYourShop: "ඔබේ වෙළඳසැලේ විස්තර සහ වින්‍යාසය සකස් කරන්න",
    backToShops: "වෙළඳසැල් වෙත ආපසු",
    
    online: "අන්තර්ජාල වෙළඳසැල",
    pos: "POS/භෞතික වෙළඳසැල",
    dropshipper: "ඩ්‍රොප්ෂිපර්",
    
    basicInformation: "මූලික තොරතුරු",
    basicInformationDesc: "ඔබේ වෙළඳසැල පිළිබඳ මූලික විස්තර සපයන්න",
    shopName: "වෙළඳසැලේ නම",
    shopNamePlaceholder: "ඔබේ වෙළඳසැලේ නම ඇතුළත් කරන්න",
    printableName: "මුද්‍රණය කළ යුතු නම",
    printableNamePlaceholder: "waybill මත මුද්‍රණය කිරීමට නම (optional)",
    printableNameHint: "සකසා ඇත්නම්, වෙළඳසැලේ නම වෙනුවට waybill label මත මෙම නම මුද්‍රණය වේ",
    shopType: "වෙළඳසැල් වර්ගය",
    orderPrefix: "ඇණවුම් අංක පූර්වය",
    prefixHint: "මෙය ඇණවුම් අංක ජනනය කිරීමට භාවිතා වේ (උදා: ABC-001)",
    addressPlaceholder: "වෙළඳසැලේ ලිපිනය ඇතුළත් කරන්න",
    phone: "දුරකථන අංකය",
    phonePlaceholder: "සම්බන්ධතා අංකය ඇතුළත් කරන්න",
    address: "ලිපිනය",
    
    shopLogo: "වෙළඳසැල් ලාංඡනය",
    logoDesc: "ඔබේ වෙළඳසැලේ ලාංඡනය උඩුගත කරන්න (විකල්ප)",
    uploadLogo: "ලාංඡනය උඩුගත කිරීමට ක්ලික් කරන්න",
    logoFormats: "PNG, JPG, WEBP 5MB දක්වා",
    
    deliveryCharges: "බෙදාහැරීමේ ගාස්තු",
    deliveryChargesDesc: "සෑම නැව්වුම් කලාපයක් සඳහාම බෙදාහැරීමේ ගාස්තු සකස් කරන්න",
    deliveryChargesHint: "සෑම කලාපයක් සඳහාම තරඟකාරී බෙදාහැරීමේ ගාස්තු සකස් කරන්න. මෙම ගාස්තු ගනුදෙනුකරුවන්ට ගෙවීමේදී පෙන්වනු ලැබේ.",
    
    serviceCharge: "සේවා ගාස්තුව",
    serviceChargeDesc: "ඩ්‍රොප්ෂිපර් ඇණවුම් සඳහා ස්ථාවර සේවා ගාස්තුව",
    serviceChargeAmount: "සේවා ගාස්තුව (LKR)",
    serviceChargeHint: "සෑම ඇණවුමකම ගෙවිය යුතු ස්ථාවර මුදල",
    
    nameRequired: "වෙළඳසැලේ නම අවශ්‍යය",
    typeRequired: "කරුණාකර වෙළඳසැල් වර්ගයක් තෝරන්න",
    prefixRequired: "ඇණවුම් පූර්වය අවශ්‍යය",
    prefixMinLength: "පූර්වය අවම වශයෙන් අක්ෂර 2ක් විය යුතුය",
    prefixTaken: "මෙම පූර්වය දැනටමත් ගෙන ඇත",
    prefixAvailable: "පූර්වය ලබා ගත හැකිය",
    invalidPhone: "කරුණාකර වලංගු දුරකථන අංකයක් ඇතුළත් කරන්න",
    deliveryChargesRequired: "කරුණාකර සියලුම කලාප සඳහා බෙදාහැරීමේ ගාස්තු සකස් කරන්න",
    serviceChargeRequired: "ඩ්‍රොප්ෂිපර්ස් සඳහා සේවා ගාස්තුව අවශ්‍යය",
    invalidServiceCharge: "කරුණාකර වලංගු සේවා ගාස්තුවක් ඇතුළත් කරන්න",
    invalidLogoFormat: "ලාංඡනය PNG, JPG, JPEG, හෝ WEBP ආකෘතියේ විය යුතුය",
    logoTooLarge: "ලාංඡන ගොනු ප්‍රමාණය 5MB ට වඩා අඩු විය යුතුය",
    
    loadingData: "දත්ත පූරණය වෙමින්...",
    loadingDataDesc: "අපි අවශ්‍ය තොරතුරු ලබා ගන්නා අතරතුර කරුණාකර රැඳී සිටින්න.",
    
    createShop: "වෙළඳසැල සාදන්න",
    
    shopCreatedSuccess: "'{{shopName}}' වෙළඳසැල සාර්ථකව සාදන ලදී!",
    failedToCreate: "වෙළඳසැල සෑදීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.",
    failedToLoadZones: "නැව්වුම් කලාප පූරණය කිරීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.",

    manageYourShops: "ඔබේ සියලුම වෙළඳසැල් සහ ඒවායේ වින්‍යාසයන් කළමනාකරණය කරන්න",
    loadingShops: "වෙළඳසැල් පූරණය වෙමින්...",
    loadingShopsDesc: "අපි ඔබේ වෙළඳසැල් ලබා ගන්නා අතරතුර කරුණාකර රැඳී සිටින්න.",
    searchShops: "නම, පූර්වය, ලිපිනය, හෝ දුරකථනය අනුව වෙළඳසැල් සොයන්න...",
    filteredResults: "වෙළඳසැල් {{total}} න් {{count}} ක්",
    totalShops: "වෙළඳසැල් {{count}} ක්",
    allShops: "සියලුම වෙළඳසැල්",
    noSearchResults: "වෙළඳසැල් හමු නොවිණි",
    noSearchResultsDesc: "ඔබේ සෙවුම් පද වෙනස් කිරීමට උත්සාහ කරන්න හෝ සියලු වෙළඳසැල් බැලීමට ෆිල්ටර ඉවත් කරන්න.",
    noShops: "තවම වෙළඳසැල් නැත",
    noShopsDesc: "ඔබේ ව්‍යාපාරික කටයුතු කළමනාකරණය කිරීම ආරම්භ කිරීමට ඔබේ පළමු වෙළඳසැල සාදන්න.",
    createFirstShop: "පළමු වෙළඳසැල සාදන්න",

    editShop: "වෙළඳසැල සංස්කරණය කරන්න",
    updateShop: "වෙළඳසැල යාවත්කාලීන කරන්න",
    updateShopDetails: "ඔබේ වෙළඳසැලේ විස්තර සහ වින්‍යාසය යාවත්කාලීන කරන්න",
    shopUpdatedSuccess: "'{{shopName}}' වෙළඳසැල සාර්ථකව යාවත්කාලීන කරන ලදී!",
    failedToUpdate: "වෙළඳසැල යාවත්කාලීන කිරීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.",
    unsavedChanges: "නොසුරකින ලද වෙනස්කම්",
    confirmDiscardChanges: "ඔබට නොසුරකින ලද වෙනස්කම් තිබේ. සුරකින්නේ නැතිව පිටවීමට ඔබට අවශ්‍යද?",
    discardChanges: "වෙනස්කම් ඉවත දමන්න",
    noChangesToSave: "සුරැකීමට වෙනස්කම් කර නැත.",
    noChanges: "වෙනස්කම් නැත",
    
    logo: "ලාංඡනය",
    type: "වර්ගය",
    prefix: "පූර්වය",
    contact: "සම්බන්ධතාව",
    
    noContact: "සම්බන්ධතා තොරතුරු නැත",
    
    confirmDelete: "ඔබට '{{shopName}}' වෙළඳසැල මකා දැමීමට අවශ්‍යද? මෙම ක්‍රියාව අහෝසි කළ නොහැක.",
    shopDeletedSuccess: "'{{shopName}}' වෙළඳසැල සාර්ථකව මකා දමන ලදී.",
    failedToDelete: "වෙළඳසැල මකා දැමීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.",

    setupExtraCharges: "අමතර බර සඳහා අමතර ගාස්තු සකස් කරන්න",
    extraChargesDesc: "පාදක බෙදාහැරීමෙන් ඔබ්බට අමතර කිලෝග්‍රෑමයකට ගාස්තු අය කරන්න",
    extraChargePerKg: "KG එකකට අමතර ගාස්තුව",
    extraChargePerKgPlaceholder: "0.00",
    extraChargesRequired: "කරුණාකර සියලු කලාප සඳහා වලංගු KG ගාස්තු ඇතුළත් කරන්න",

    // Catalog Settings
    catalogSettings: "පොදු නාමාවලිය",
    catalogSettingsDesc: "ගනුදෙනුකරුවන්ට නාමාවලි සබැඳියක් හරහා නිෂ්පාදන පෙනීමට සහ ඇණවුම් ලබා දීමට ඉඩ දෙන්න",
    catalogEnabled: "පොදු නාමාවලිය සක්‍රිය කරන්න",
    catalogEnabledHint: "සක්‍රිය කළ විට, ගනුදෙනුකරුවන්ට ඔබේ නාමාවලි URL හරහා නිෂ්පාදන බැලීමට සහ ඇණවුම් ලබා දීමට හැකිය",
    catalogSlug: "නාමාවලි URL",
    catalogSlugPlaceholder: "උදා: my-shop",
    catalogSlugHint: "අකුරු 3–80, කුඩා අකුරු, ඉලක්කම් සහ '-' පමණක්",
    catalogSlugAvailable: "URL ලබාගත හැකිය",
    catalogSlugTaken: "මෙම URL දැනටමත් භාවිතා වෙමින් ඇත",
    catalogSlugInvalid: "වැරදි URL ආකෘතිය",
    catalogSlugRequired: "නාමාවලිය සක්‍රිය කිරීමට URL එකක් අවශ්‍ය වේ",
    generateSlug: "නමෙන් ජනනය කරන්න",

    // Message Center Shift Settings
    messageCenterShiftSettings: "Message Center Shifts",
    messageCenterShiftSettingsDesc: "මෙම shop හි orders සඳහා message center shift යෙදිය හැකිද යන්න පාලනය කරන්න",
    messageCenterShiftEligible: "මෙම shop සඳහා Message Center Shifts සක්‍රිය කරන්න",
    messageCenterShiftEligibleHint: "සක්‍රිය කළහොත්, මෙම shop හි orders වෙත message center shift එකක් යෙදිය හැක",
    catalogPreviewLink: "නාමාවලිය පෙරදර්ශනය",
    catalogUrlLabel: "ඔබේ නාමාවලි URL වනුයේ:",

    // POS Settings
    posSettings: "POS සැකසුම්",
    posSettingsDesc: "මෙම වෙළඳසැල සඳහා POS හැසිරීම වින්‍යාස කරන්න",
    allowCreditSales: "ණය විකිණීම් අනුමත කරන්න",
    allowCreditSalesHint: "සම්පූර්ණ ගෙවීමකින් තොරව ණය ගනුදෙනු සම්පූර්ණ කිරීමට cashier ලාට ඉඩ දෙන්න",
    cashierSessionRequired: "Cashier සැසිය අනිවාර්ය කරන්න",
    cashierSessionRequiredHint: "POS terminal භාවිතා කිරීමට පෙර cashier ලා සැසියක් ආරම්භ කළ යුතුය",

    // WooCommerce Webhook Integration
    woocommerceIntegration: "WooCommerce ඒකාබද්ධතාව",
    woocommerceIntegrationDesc: "ඔබේ WooCommerce වෙළඳසැලේ orders ලබා දුන් විට ඒවා ස්වයංක්‍රීයව Rettzy හි සාදන්න",
    woocommerceWebhookEnabled: "WooCommerce Webhook සක්‍රිය කරන්න",
    woocommerceWebhookEnabledHint: "සක්‍රිය කළහොත්, WooCommerce හට නව orders සහ ගෙවීම් යාවත්කාලීන කෙලින්ම Rettzy වෙත යැවිය හැක",
    woocommerceWebhookEnabledSuccess: "WooCommerce webhook සක්‍රිය කරන ලදී",
    woocommerceWebhookDisabledSuccess: "WooCommerce webhook අක්‍රිය කරන ලදී",
    woocommerceWebhookToggleFailed: "WooCommerce webhook තත්ත්වය යාවත්කාලීන කිරීමට අසමත් විය. නැවත උත්සාහ කරන්න.",
    woocommerceWebhookSecret: "Webhook රහස",
    woocommerceWebhookSecretHint: "WooCommerce හි webhook topics දෙකෙහිම Secret ක්ෂේත්‍රයට මෙය ඇලවන්න",
    woocommerceOrderCreatedUrl: "Order Created Webhook URL",
    woocommerceOrderStatusUpdatedUrl: "Order Status Updated Webhook URL",
    woocommerceRegenerateSecret: "රහස නැවත ජනනය කරන්න",
    woocommerceRegenerateSecretConfirmTitle: "Webhook රහස නැවත ජනනය කරන්න",
    woocommerceRegenerateSecretConfirm: "මෙය වත්මන් රහස අවලංගු කරයි. WooCommerce හි webhook topics දෙකෙහිම Secret ක්ෂේත්‍රය අලුත් අගය සමඟ යාවත්කාලීන කළ යුතුය.",
    woocommerceRegenerateSecretSuccess: "Webhook රහස නැවත ජනනය කරන ලදී. එය WooCommerce හි යාවත්කාලීන කරන්න.",
    woocommerceRegenerateSecretFailed: "Webhook රහස නැවත ජනනය කිරීමට අසමත් විය. නැවත උත්සාහ කරන්න.",
    woocommerceShowSecret: "රහස පෙන්වන්න",
    woocommerceHideSecret: "රහස සඟවන්න",
    woocommerceCopy: "පිටපත් කරන්න",
    woocommerceCopied: "clipboard වෙත පිටපත් කරන ලදී",
    woocommerceCopyFailed: "පිටපත් කිරීමට අසමත් විය. කරුණාකර මෙය අතින් පිටපත් කරන්න.",
    woocommerceLastReceivedAt: "අවසන් webhook ලැබුණේ: {{date}}",
    woocommerceNeverReceived: "තවම webhook එකක් ලැබී නැත",
    woocommerceSetupHint: "WooCommerce හි, Settings → Advanced → Webhooks වෙත ගොස් පහත URL එක් එක් සඳහා webhook එකක් සාදන්න (topics: Order created / Order updated), අදාළ URL එක සහ Secret එක ඇලවන්න.",
    woocommerceApiTitle: "WooCommerce REST API (අතින් ඇණවුම් සමමුහුර්ත කිරීම)",
    woocommerceApiDesc: "මග හැරුණු webhook නිසා නොලැබුණු ඇණවුම් Rettzy වෙත ලබා ගැනීමට ඉඩ දේ. WooCommerce → Settings → Advanced → REST API හි Read-only API key එකක් සාදන්න.",
    woocommerceStoreUrl: "වෙළඳසැල් URL",
    woocommerceStoreUrlPlaceholder: "https://your-store.com",
    woocommerceConsumerKey: "Consumer Key",
    woocommerceConsumerSecret: "Consumer Secret",
    woocommerceKeySaved: "සුරකින ලදී: {{key}}. දැනට ඇති key එක තබා ගැනීමට හිස්ව තබන්න.",
    woocommerceSecretSaved: "•••••••• සුරකින ලදී — තබා ගැනීමට හිස්ව තබන්න",
    woocommerceSaveApi: "API credentials සුරකින්න",
    woocommerceTestConnection: "සම්බන්ධතාව පරීක්ෂා කරන්න",
    woocommerceApiSaveSuccess: "WooCommerce API credentials සුරකින ලදී",
    woocommerceApiSaveFailed: "WooCommerce API credentials සුරැකීම අසාර්ථකයි",
    woocommerceTestSuccess: "WooCommerce සම්බන්ධතාව සාර්ථකයි",
    woocommerceTestFailed: "WooCommerce වෙත සම්බන්ධ විය නොහැක",
    woocommerceSaveCredentialsFirst: "සම්බන්ධතාව පරීක්ෂා කිරීමට පෙර API credentials සුරකින්න",
    woocommerceSyncTitle: "WooCommerce ඇණවුම් සමමුහුර්තකරණය",
    woocommerceSyncDesc: "මග හැරුණු webhook නිසා නොලැබුණු ඇණවුම් WooCommerce වෙතින් කෙලින්ම ලබා ගන්න.",
    woocommerceSyncSelectShop: "වෙළඳසැල",
    woocommerceSyncChooseShop: "වෙළඳසැලක් තෝරන්න",
    woocommerceSyncNoShops: "WooCommerce webhook සක්‍රිය කළ වෙළඳසැල් නැත. පළමුව Edit Shop හි එය සක්‍රිය කරන්න.",
    woocommerceSyncMissingCredentials: "මෙම වෙළඳසැලට තවමත් WooCommerce REST API keys නැත.",
    woocommerceSyncAddCredentials: "Edit Shop හි API keys එක් කරන්න",
    woocommerceSyncLastSync: "අවසන් අතින් සමමුහුර්තය: {{date}}",
    woocommerceSyncNeverSynced: "තවම අතින් සමමුහුර්ත කර නැත",
    woocommerceSyncByIdTitle: "ඇණවුමක් සමමුහුර්ත කරන්න",
    woocommerceSyncByIdDesc: "WooCommerce ඇණවුම් අංකයක් ඇතුළත් කරන්න. ඇණවුම Rettzy හි සාදනු ලැබේ, හෝ දැනටමත් තිබේ නම් යාවත්කාලීන වේ.",
    woocommerceSyncOrderIdLabel: "WooCommerce ඇණවුම් අංකය",
    woocommerceSyncFetch: "ලබාගෙන සමමුහුර්ත කරන්න",
    woocommerceSyncByDateTitle: "දිනය අනුව ඇණවුම් සමමුහුර්ත කරන්න",
    woocommerceSyncByDateDesc: "තෝරාගත් දිනයේ සාදන ලද සියලු WooCommerce ඇණවුම් (උපරිම 500) ලබාගෙන Rettzy හි සාදන්න හෝ යාවත්කාලීන කරන්න.",
    woocommerceSyncDateLabel: "ඇණවුම් දිනය",
    woocommerceSyncOrders: "ඇණවුම් සමමුහුර්ත කරන්න",
    woocommerceSyncing: "සමමුහුර්ත කරමින්…",
    woocommerceSyncingHint: "මෙයට මිනිත්තුවක් පමණ ගත විය හැක. කරුණාකර මෙම පිටුව විවෘතව තබන්න.",
    woocommerceSyncConfirmTitle: "WooCommerce ඇණවුම් සමමුහුර්ත කරන්න",
    woocommerceSyncConfirm: "{{shop}} හි {{date}} දින සාදන ලද සියලු WooCommerce ඇණවුම් ලබාගෙන Rettzy හි සාදන්න හෝ යාවත්කාලීන කරන්නද?",
    woocommerceSyncResults: "සමමුහුර්ත ප්‍රතිඵල",
    woocommerceSyncTotal: "මුළු",
    woocommerceSyncCreated: "සාදන ලදී",
    woocommerceSyncUpdated: "යාවත්කාලීන කළා",
    woocommerceSyncSkipped: "මඟ හැරියා",
    woocommerceSyncFailed: "අසාර්ථකයි",
    woocommerceSyncColWcId: "WooCommerce ඇණවුම",
    woocommerceSyncColStatus: "ප්‍රතිඵලය",
    woocommerceSyncColOrder: "Rettzy ඇණවුම",
    woocommerceSyncColMessage: "විස්තර",
    woocommerceSyncNoOrders: "එම දිනට WooCommerce ඇණවුම් හමු නොවීය.",
    woocommerceSyncCopyFailed: "අසාර්ථක ඇණවුම් අංක පිටපත් කරන්න",
    woocommerceSyncError: "WooCommerce සමමුහුර්තය අසාර්ථකයි",
    woocommerceSyncInvalidOrderId: "වලංගු WooCommerce ඇණවුම් අංකයක් ඇතුළත් කරන්න",
    woocommerceSyncLoadFailed: "වෙළඳසැල් පූරණය අසාර්ථකයි",

    // Bundle products
    bundleConfigure: "Configure Bundle Pricing",
    bundleComponentsMissing: "These bundle products are not assigned to this shop: {products}",
    bundlePrice: "Bundle Price",
    unitValue: "Unit Value",
    lineDiscount: "Discount",
    bundleLoadFailed: "Failed to load bundle details",
}